import AssetLoader from "../loader/AssetLoader.js";
import { Box } from "./Box.js";
import "../loader/ImageLoader.js";
import "../global-33d5eebf.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "./UIElement.js";
import "./Rectangle.js";
import "nanoid";
import "./utils.js";
import "lodash";
import "./UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
class ImageBox extends Box {
  move(x, y) {
    this.bounds.x = x;
    this.bounds.y = y;
    this._hasChanged = true;
  }
  updateImage(imageKey) {
    this.config.imageKey = imageKey;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  updateInternal(gameModel) {
  }
  calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }
  _update() {
    super._update();
    if (!this.isVisible()) {
      return;
    }
    const imageElement = this.element;
    if (!imageElement) {
      return;
    }
    imageElement.className = "image-box";
    if (this._config.flipX && this._config.flipY) {
      imageElement.style.transform = "scale(-1,-1)";
    } else if (this._config.flipX) {
      imageElement.style.transform = "scale(-1,1)";
    } else if (this._config.flipY) {
      imageElement.style.transform = "scale(1,-1)";
    }
    if (!this._config.imageKey) {
      imageElement.style.backgroundImage = "none";
      return;
    }
    const img = AssetLoader.getInstance().getImage(this._config.imageKey).image;
    imageElement.style.backgroundImage = "url(" + img.src + ")";
    imageElement.style.backgroundSize = this._config.backgroundSize ?? "contain";
    imageElement.style.backgroundRepeat = "no-repeat";
  }
}
export {
  ImageBox
};
//# sourceMappingURL=ImageBox.js.map
